import { render, staticRenderFns } from "./airtrek.vue?vue&type=template&id=89b9733a&scoped=true"
import script from "./airtrek.vue?vue&type=script&lang=js"
export * from "./airtrek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b9733a",
  null
  
)

export default component.exports